import styled from 'styled-components';

interface TextComponentProps {
    color?: string;
    isItalic?: boolean;
}

export const TextWrapper = styled.p<TextComponentProps>`
    font-weight: 400;
    line-height: 1.5;
    font-style: ${({ isItalic }) => (isItalic ? 'italic' : 'normal')};
    color: ${({ color }) => color || '#212529'};
`;
